import { Navigate } from "react-router-dom"
import { environment } from "../environment"
import { ShowToastUserSessionRefreshError, ShowToastUserSessionRefreshSuccess } from "../shared/Notifications/Toasters"

export const useTokenRefresh = () => {



    const callKeycloakTokenRefresh = (keycloak, axiosInstanceRef, translateFunc, showSuccessToast = false) => {

        return new Promise((resolve, reject) => {
            keycloak.updateToken(environment.KEYCLOAK_ACCESS_TOKEN_VALIDITY)
                .then(res => {
                    //console.log("KEYCLOAK TOKEN REFRESH SUCCESS =============> ", res)                    
                    if (showSuccessToast) ShowToastUserSessionRefreshSuccess(translateFunc)

                    //--------------------------------------------------------------
                    // AXIOS - UPDATE TOKEN INTERCEPTOR
                    //--------------------------------------------------------------
                    axiosInstanceRef.interceptors.request.use(function (config) {
                        const kcToken = keycloak.token
                        //console.log("INTERCEPTECT !!!!", config)
                        config.headers.Authorization = `Bearer ${kcToken}`;

                        return config;
                    });


                    resolve(res)
                })
                .catch(error => {
                    console.log("KEYCLOAK TOKEN REFRESH ERROR", error)
                    ShowToastUserSessionRefreshError(translateFunc)
                    reject()

                    keycloak.logout()
                    Navigate('/')
                })
        })

    }


    return {
        callKeycloakTokenRefresh
    }
}